angular.module("ainapp")
    .controller("AccountMasterController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Chart Of Accounts";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            MainService.CitiesInDropdown().then(function (response) {
                $scope.Cities = response.data;
            });

            MainService.CostCenterList().then(function (response) {
                $scope.CostCenters = response.data;
            });

            MainService.AccountTypesInDropdown().then(function (response) {
                $scope.AccountTypes = response.data;
            });

            $scope.Init = function () {

                //                $scope.Accounts = [];
                //                MainService.AccountList().then(function (response) {
                //                    $scope.Accounts = response.data;
                //                    $scope.AccLoad = false;
                //                });

                $scope.CurrentTransAccount = {
                    Name: "",
                    NameAr: "",
                    ParentId: "",
                    IsActive: true,
                    IsGroup: false,
                    Level: 0,
                    AccountTypeId: "",
                    Description: "",

                    PhoneNo: "",
                    MobileNo: "",
                    Email: "",
                    CreditDays: 0,
                    CreditLimit: 0,
                    ContactPerson: "",
                    ContactPersonNo: "",
                    TRNNo: "",
                    VATType: "",
                    LicenseExpiryDate: null,
                    Address: "",
                    CityId: "",
                    VATId: "",
                    FaxNo: "",
                    PassportNo: "",
                    LicenseNo: "",


                }

                $scope.load = false;
                $scope.viewVal = 0;
                $scope.isSearch = false;

                $scope.selectedGroup = {};
                $scope.selectedAcctype = {};

                $scope.AccFilter = {
                    Keyword: "",
                }

            }
            $scope.Init();


            $scope.treelistOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {
                            MainService.AccountsInKendoTree().then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success([]);
                                toastr.error("NetworkError");
                            })
                        },
                    },

                    schema: {
                        model: {
                            id: "Id",
                            parentId: "ParentId",
                            fields: {
                                Id: {
                                    field: "Id",
                                    type: "number",
                                    nullable: false
                                },
                                ParentId: {
                                    field: "ParentId",
                                    type: "number",
                                    nullable: true
                                },
                                Name: {
                                    field: "Name",
                                    type: "string"
                                },
                                IsGroup: {
                                    field: "IsGroup",
                                    type: "boolean"
                                },
                                AccountCode: {
                                    field: "AccountCode",
                                    type: "string"
                                },
                                "AccountType.Name": {
                                    //field: "AccountCode",
                                    type: "string"
                                }
                            },
                            expanded: false
                        }
                    }
                },

                editable: false,
                toolbar: ["excel"],
                height: 600,
                sortable: true,
                filterable: true,
                pageable: {
                    pageSize: 50,
                    pageSizes: true
                },

                columns: [
                    {
                        headerTemplate: "<input  style='margin-left:5px;text-aligh:right'  type='checkbox' ng-model='selectAllAccRows' ng-click='selectAllAccounts(this)'/>",
                        template: "<input style='margin-left:10px; text-aligh:right' type='checkbox'  kendo-select={{dataItem.selected}} ng-model='dataItem.checked' ng-change='selectAccountsHead(dataItem)' />",
                        width: "100px",
                    },
                    {
                        field: "AccountCode",
                        title: "Account Code",
                    },
                    {
                        field: "Name",
                        title: "Name",
                    },
                    {
                        field: "AccountType.Name",
                        title: "Account Type",
                    },
                    {
                        title: "Options",
                        template: "<button ng-if='dataItem.IsGroup' class=' btn-default btn-sm fa fa-plus' ng-click='ShowAddModel(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-pencil' ng-click='ShowEditModel(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccount(dataItem)'></button> <button class=' btn-default btn-sm fa fa-arrows'  ng-click='moveAccount(dataItem)'></button>  ",
                        width: '120px'
                    },

                ],
            };

            $scope.selectAllAccounts = function (ele) {
                $scope.selectAllAccRows = !$scope.selectAllAccRows;
                if ($scope.selectAllAccRows) {
                    angular.forEach($scope.ktl.dataSource.data(), function (row) {
                        row.checked = true;
                    });
                } else {
                    angular.forEach($scope.ktl.dataSource.data(), function (row) {
                        row.checked = false;
                    });
                }
                var grid = $scope.ktl;
                if ($scope.selectAllAccRows) {
                    grid.table.find("tr").addClass("k-state-selected");
                } else {
                    grid.table.find("tr").removeClass("k-state-selected");
                }
            };

            $scope.selectAccountsHead = function (data) {
                //data.checked = !data.checked;
                var rows = $scope.ktl.dataSource.data();
                var tt = data.checked;
                if (tt) {
                    angular.forEach(rows, function (e) {
                        if (e.ParentId == data.Id) {
                            e.checked = true;
                            $scope.selectAccountsHead(e);
                        }
                    });
                } else {
                    angular.forEach(rows, function (e) {
                        if (e.ParentId == data.Id) {
                            e.checked = false;
                            $scope.selectAccountsHead(e);
                        }
                    });
                }
            };


            $scope.searchAcc = function () {
                $scope.ktl.options.dataSource.schema.model.expanded = true;
                $scope.ktl.setDataSource($scope.ktl.options.dataSource);
                $scope.ktl.dataSource.filter({
                    field: "Name",
                    operator: "contains",
                    value: $scope.AccFilter.Keyword
                });
            }

            $scope.resetAcc = function () {
                $scope.ktl.dataSource.filter({});
                $scope.ktl.options.dataSource.schema.model.expanded = false;
                $scope.ktl.setDataSource($scope.ktl.options.dataSource);
            }


            $scope.AccountListByKeyword = function () {
                $scope.load = true;
                $scope.isSearch = true;
                MainService.AccountListByKeyword($scope.AccFilter).then(function (response) {
                    $scope.SelectedAccounts = [];
                    $scope.Accounts = response.data;
                    $scope.load = false;
                });
            }

            $scope.GetSub = function (data) {
                MainService.AccountSubList(data.Id).then(function (response) {
                    data.Children = response.data;
                    data.IsOpen = true;
                });
            }

            $scope.CloseSub = function (data) {
                data.IsOpen = false;
            }

            $scope.ShowAddModel = function (data) {
                $scope.selectedGroup = data;
                $scope.selectedAcctype = data.AccountType;
                $scope.CurrentTransAccount.AccountTypeId = data.AccountTypeId;
                $scope.CurrentTransAccount.Level = data.Level + 1;
                $scope.CurrentTransAccount.IsGroup = false;
                $scope.CurrentTransAccount.ParentId = data.Id;
                $('#addTransAccountModal').modal('show');
            }

            $scope.ShowEditModel = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.GetAccountById(data.Id).then(function (response) {
                    $scope.CurrentTransAccount = response.data;
                    $scope.selectedAcctype = response.data.AccountType;
                    $('#addTransAccountModal').modal('show');
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    $scope.Init();
                    toastr.error("Network Error");
                });

            }



            $scope.getAccountType = function () {
                angular.forEach($scope.AccountTypes, function (e) {
                    if (e.Id == $scope.CurrentTransAccount.AccountTypeId) {
                        $scope.selectedAcctype = e;
                    }
                })
            }


            $scope.DeleteBulk = function () {

                $scope.checkedItemsDelete = [];
                var treeData = $scope.ktl.dataSource.data();
                $scope.checkedItemsDelete = treeData.filter(item => item.checked === true);
                // console.log(checkedItems); 
                if($scope.checkedItemsDelete.length <= 0){
                     toastr.warning("Select Accounts");
                } else{
                    $('#deleteBulkModal').modal('show');
                } 

            }

            $scope.deleteBulkAccWithConfirm = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                var checkedIds = $scope.checkedItemsDelete.filter(item => item.checked === true).map(item => item.Id);

                MainService.DeleteBulkAccountMasters(checkedIds).then(function (response) {
                    if (response.data == "Success") {
                        $('#deleteBulkModal').modal('hide');
                        toastr.success("Deleted");
                        $scope.checkedItemsDelete = [];
                        $scope.resetAcc();
                    } else {
                        toastr.warning(response.data);
                        $scope.checkedItemsDelete = [];
                        $('#deleteBulkModal').modal('hide');
                         $scope.resetAcc();
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });

            }

            $scope.AddAccount = function () {
                if ($scope.CurrentTransAccount.Name == "") {
                    toastr.warning("Give Account Name");
                } else if ($scope.CurrentTransAccount.AccountTypeId == "") {
                    toastr.warning("Select Account Type");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.SaveAccounts($scope.CurrentTransAccount).then(function (response) {
                        $scope.load = false;
                        if (response.data == 0) {
                            toastr.error("Something Went Wrong");
                        } else if (response.data == 1) {
                            toastr.success("Saved");
                            $scope.resetAcc();
                            $('#addTransAccountModal').modal('hide');
                            $scope.Init();
                        } else if (response.data == 2) {
                            toastr.error("Account Limit Reached");
                        } else if (response.data == 3) {
                            toastr.error("Name Exist");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        $scope.Init();
                        toastr.error("Network Error");
                    });
                }
            }

            $scope.updateTransAccount = function () {

                if ($scope.CurrentTransAccount.Name == "") {
                    toastr.warning("Give Account Name");
                } else if ($scope.CurrentTransAccount.AccountTypeId == "") {
                    toastr.warning("Select Account Type");
                } else {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.UpdateAccount($scope.CurrentTransAccount).then(function (response) {
                        $scope.load = false;
                        if (response.data == 1) {
                            toastr.success("Saved");
                            $scope.resetAcc();
                            $('#addTransAccountModal').modal('hide');
                        } else if (response.data == 2) {
                            toastr.error("Name Exist");
                        } else {
                            toastr.error("Failed");
                            $scope.Init();
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        $scope.Init();
                        toastr.error("Network Error");
                    });
                }

            }


            $scope.SelectedAccForDelete = {};
            $scope.DeleteAccount = function (data) {
                $scope.SelectedAccForDelete = data;
                $("#myModal2").modal("show");
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteAccountMaster($scope.SelectedAccForDelete.Id).then(function (response) {
                    if (response.data == "Success") {
                        $('#myModal2').modal('hide');
                        toastr.success("Deleted");
                        $scope.SelectedAccForDelete = {};
                        $scope.resetAcc();
                    } else {
                        toastr.warning(response.data);
                        $scope.SelectedAccForDelete = {};
                        $('#myModal2').modal('hide');
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }



            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.accountInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("Network Error");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.PayableAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransAccount.PDCPayableAccountName = data.Name;
                    $scope.CurrentTransAccount.PDCPayableAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.ReceivableAccountOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentTransAccount.PDCReceivableAccountName = data.Name;
                    $scope.CurrentTransAccount.PDCReceivableAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.refreshMainAccount = function () {
                $('#addAccountModal').modal('hide');
                $('#addAccountModal2').modal('hide');
                $('#addTransAccountModal').modal('hide');
                $('#editAccountModal').modal('hide');
                $('#editTransAccountModal').modal('hide');
                $scope.Init();
            }

            $scope.moveAccount = function (data) {

                if (data.Level == 1) {
                    toastr.warning("Level 1 Cannot Move");
                } else {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    $scope.AccountParentList = [];
                    $scope.selectedMoveAccount = data;
                    MainService.GetParentsByAccountType(data.Id).then(function (response) {
                        if (response.data) {
                            $('#moveAccountModal').modal('show');
                            $scope.AccountParentList = response.data;
                        } else {
                            toastr.warning("Network Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });

                }

            }

            $scope.updateParentAccount = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.UpdateAccountGroup($scope.selectedMoveAccount).then(function (response) {
                    if (response.data) {
                        $('#moveAccountModal').modal('hide');
                        toastr.success("Success");
                        $scope.selectedMoveAccount = {};
                        $scope.resetAcc();
                    } else {
                        toastr.warning("Network Error");
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }

        }])
